export default "__VITE_ASSET__COmgsBC4__"